import type { ZealyRewards } from '~/api/types/zealy-rewards'

export async function fetchZealyRewards(
  zealyRewardsContractAddress: string,
  account: string
): Promise<ZealyRewards> {
  const ZEALY_REWARDS_URL = `https://data.tenset.io/proofs/${zealyRewardsContractAddress}/rewards/${account}`

  return await fetch(ZEALY_REWARDS_URL).then<ZealyRewards>(response =>
    response.json()
  )
}
